export default function Container(props) {
    return (
        <div style={{ marginBottom: '30px' }}>
            {props.children}
        </div>
    );
}